import { addValue } from "../actions";

export const FORM_STATUS = {
	0: "черновик",
	1: "утверждена",
	2: "на утверждении",
	3: "отклонена",
	6: "отправлена",
	7: "получена",
	9: "согласована",
	10: "на утверждении",
	11: "утверждена",
	12: "оплачена",
	14: "закрыта",
	21: "допущена к защите",
	22: "не допущена к защите",
	34: "не утверждена",
	44: "не согласована",
};

export const FORM_LABELS = {
	// 0: "primary",
	// 1: "success",
	// 2: "secondary",
	// 3: "warning",
	// 4: "secondary",
	// 5: "secondary",
	// 6: "secondary",
	// 7: "secondary",
	// 8: "warning",
	// 9: "secondary",
	// 10: "secondary",
	0: "primary",
	1: "success",
	2: "secondary",
	3: "warning",
	6: "отправлена",
	7: "success",
	9: "success",
	10: "secondary",
	11: "утверждена",
	12: "success",
	14: "secondary",
	21: "success",
	22: "warning",
	34: "warning",
	44: "warning",
};

export const INITIAL_RULES = {
	set_full_name: {
		valueName: "ContactFullName",
		callback(dispatch, values) {
			if (typeof SK !== "undefined" && values.filter((value) => value.id === "ContactFullName").length <= 0) {
				// eslint-disable-next-line no-undef
				const { first_name, last_name, middle_name } = SK.user();
				const value = `${last_name || ""} ${first_name || ""} ${middle_name || ""}`.trim();
				if (value && value.length > 0) {
					dispatch(addValue("ContactFullName", value, false));
				}
			}
		},
	},
	set_phone: {
		valueName: "ContactPhone",
		callback(dispatch, values) {
			if (typeof SK !== "undefined" && values.filter((value) => value.id === "ContactPhone").length <= 0) {
				// eslint-disable-next-line no-undef
				const { phone } = SK.user();
				if (phone && phone.length > 0) {
					dispatch(addValue("ContactPhone", phone, false));
				}
			}
		},
	},
	set_email: {
		valueName: "ContactEmail",
		callback(dispatch, values) {
			if (typeof SK !== "undefined" && values.filter((value) => value.id === "ContactEmail").length <= 0) {
				// eslint-disable-next-line no-undef
				const { email } = SK.user();
				if (email && email.length > 0) {
					dispatch(addValue("ContactEmail", email, false));
				}
			}
		},
	},
};

export const getFormTitle = ({ process_id }) => `Заявка №${process_id}`;
export const getFormSubtitle = ({ typeForm }) => typeForm || "";
